import { render, staticRenderFns } from "./SalesOrderList.vue?vue&type=template&id=5a66d367&"
import script from "./SalesOrderList.vue?vue&type=script&lang=js&"
export * from "./SalesOrderList.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
